import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import {
  EmailAddressSerializer_getInstancezn5b5405tqyz as EmailAddressSerializer_getInstance,
  EmailAddress1cvm8sbtoer9i as EmailAddress,
  EmailAddress__toString_impl_artjh3fv1lb2pg4oqn as EmailAddress__toString_impl_artjh3,
  EmailAddress__hashCode_impl_wizg9y14xq3olyjcev0 as EmailAddress__hashCode_impl_wizg9y,
} from '../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { SealedClassSerializeriwipiibk55zc as SealedClassSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SealedSerializer.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import {
  Companion_instance13way2il9a8jt as Companion_instance,
  Enum3alwj03lh1n41 as Enum,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function SignatureStatusDetails$Companion$$childSerializers$_anonymous__yb0npu() {
  return Companion_getInstance_4().serializer_9w0wvi_k$();
}
function SignatureStatusDetails$Companion$$childSerializers$_anonymous__yb0npu_0() {
  return new (ArrayListSerializer())($serializer_getInstance_2());
}
function SignatureStatusDetails$Companion$$childSerializers$_anonymous__yb0npu_1() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), StringSerializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, SignatureStatusDetails$Companion$$childSerializers$_anonymous__yb0npu);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, SignatureStatusDetails$Companion$$childSerializers$_anonymous__yb0npu_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, tmp_1, tmp_3, null, lazy(tmp_4, SignatureStatusDetails$Companion$$childSerializers$_anonymous__yb0npu_1)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.SignatureStatusDetails', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('envelopeId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('status', false);
        tmp0_serialDesc.addElement_5pzumi_k$('signerStatuses', false);
        tmp0_serialDesc.addElement_5pzumi_k$('completedAt', true);
        tmp0_serialDesc.addElement_5pzumi_k$('metadata', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_pqyyb_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.envelopeId_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.status_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.signerStatuses_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.completedAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, InstantSerializer_getInstance(), value.completedAt_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !equals(value.metadata_1, emptyMap())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.metadata_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_pqyyb_k$(encoder, value instanceof SignatureStatusDetails() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp10_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, InstantSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp10_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SignatureStatusDetails().new_org_thecommunitygroupinc_cares_SignatureStatusDetails_wir3we_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), tmp0_cached[2].get_value_j01efc_k$(), get_nullable(InstantSerializer_getInstance()), tmp0_cached[4].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var SignatureStatusDetailsClass;
function SignatureStatusDetails() {
  if (SignatureStatusDetailsClass === VOID) {
    class $ {
      constructor(envelopeId, status, signerStatuses, completedAt, metadata) {
        Companion_getInstance();
        completedAt = completedAt === VOID ? null : completedAt;
        metadata = metadata === VOID ? emptyMap() : metadata;
        this.envelopeId_1 = envelopeId;
        this.status_1 = status;
        this.signerStatuses_1 = signerStatuses;
        this.completedAt_1 = completedAt;
        this.metadata_1 = metadata;
      }
      toString() {
        return 'SignatureStatusDetails(envelopeId=' + this.envelopeId_1 + ', status=' + this.status_1.toString() + ', signerStatuses=' + toString(this.signerStatuses_1) + ', completedAt=' + toString_0(this.completedAt_1) + ', metadata=' + toString(this.metadata_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.envelopeId_1);
        result = imul(result, 31) + this.status_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.signerStatuses_1) | 0;
        result = imul(result, 31) + (this.completedAt_1 == null ? 0 : this.completedAt_1.hashCode()) | 0;
        result = imul(result, 31) + hashCode(this.metadata_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SignatureStatusDetails()))
          return false;
        if (!(this.envelopeId_1 === other.envelopeId_1))
          return false;
        if (!this.status_1.equals(other.status_1))
          return false;
        if (!equals(this.signerStatuses_1, other.signerStatuses_1))
          return false;
        if (!equals(this.completedAt_1, other.completedAt_1))
          return false;
        if (!equals(this.metadata_1, other.metadata_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_SignatureStatusDetails_wir3we_k$(seen0, envelopeId, status, signerStatuses, completedAt, metadata, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.envelopeId_1 = envelopeId;
        $this.status_1 = status;
        $this.signerStatuses_1 = signerStatuses;
        if (0 === (seen0 & 8))
          $this.completedAt_1 = null;
        else
          $this.completedAt_1 = completedAt;
        if (0 === (seen0 & 16))
          $this.metadata_1 = emptyMap();
        else
          $this.metadata_1 = metadata;
        return $this;
      }
    }
    initMetadataForClass($, 'SignatureStatusDetails', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    SignatureStatusDetailsClass = $;
  }
  return SignatureStatusDetailsClass;
}
function SignatureSession$Companion$$childSerializers$_anonymous__bd7444() {
  return new (LinkedHashMapSerializer())(EmailAddressSerializer_getInstance(), Companion_instance_3.serializer_9w0wvi_k$());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, SignatureSession$Companion$$childSerializers$_anonymous__bd7444), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new (Companion_0())();
  return Companion_instance_1;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.SignatureSession', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('envelopeId', false);
        tmp0_serialDesc.addElement_5pzumi_k$('redirects', false);
        tmp0_serialDesc.addElement_5pzumi_k$('expiresAt', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_7outbn_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.envelopeId_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.redirects_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.expiresAt_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, InstantSerializer_getInstance(), value.expiresAt_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_7outbn_k$(encoder, value instanceof SignatureSession() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, InstantSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SignatureSession().new_org_thecommunitygroupinc_cares_SignatureSession_hqey6_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), get_nullable(InstantSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var SignatureSessionClass;
function SignatureSession() {
  if (SignatureSessionClass === VOID) {
    class $ {
      constructor(envelopeId, redirects, expiresAt) {
        Companion_getInstance_0();
        expiresAt = expiresAt === VOID ? null : expiresAt;
        this.envelopeId_1 = envelopeId;
        this.redirects_1 = redirects;
        this.expiresAt_1 = expiresAt;
      }
      toString() {
        return 'SignatureSession(envelopeId=' + this.envelopeId_1 + ', redirects=' + toString(this.redirects_1) + ', expiresAt=' + toString_0(this.expiresAt_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.envelopeId_1);
        result = imul(result, 31) + hashCode(this.redirects_1) | 0;
        result = imul(result, 31) + (this.expiresAt_1 == null ? 0 : this.expiresAt_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SignatureSession()))
          return false;
        if (!(this.envelopeId_1 === other.envelopeId_1))
          return false;
        if (!equals(this.redirects_1, other.redirects_1))
          return false;
        if (!equals(this.expiresAt_1, other.expiresAt_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_SignatureSession_hqey6_k$(seen0, envelopeId, redirects, expiresAt, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.envelopeId_1 = envelopeId;
        $this.redirects_1 = redirects;
        if (0 === (seen0 & 4))
          $this.expiresAt_1 = null;
        else
          $this.expiresAt_1 = expiresAt;
        return $this;
      }
    }
    initMetadataForClass($, 'SignatureSession', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    SignatureSessionClass = $;
  }
  return SignatureSessionClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function SigningRedirect$EmailSent$_anonymous__xdngze() {
  var tmp = EmailSent_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('EmailSent', tmp, tmp$ret$0);
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('Embedded', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('url', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_9f3gos_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.url_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_9f3gos_k$(encoder, value instanceof Embedded() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Embedded().new_org_thecommunitygroupinc_cares_SigningRedirect_Embedded_64uu1d_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var EmailSentClass;
function EmailSent() {
  if (EmailSentClass === VOID) {
    class $ {
      constructor() {
        EmailSent_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, SigningRedirect$EmailSent$_anonymous__xdngze);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
      toString() {
        return 'EmailSent';
      }
      hashCode() {
        return -1810265490;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof EmailSent()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'EmailSent', VOID, VOID, [SigningRedirect(), SerializerFactory()], VOID, VOID, {0: EmailSent_getInstance});
    EmailSentClass = $;
  }
  return EmailSentClass;
}
var EmailSent_instance;
function EmailSent_getInstance() {
  if (EmailSent_instance === VOID)
    new (EmailSent())();
  return EmailSent_instance;
}
var EmbeddedClass;
function Embedded() {
  if (EmbeddedClass === VOID) {
    class $ {
      constructor(url) {
        this.url_1 = url;
      }
      toString() {
        return 'Embedded(url=' + this.url_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.url_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Embedded()))
          return false;
        if (!(this.url_1 === other.url_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_SigningRedirect_Embedded_64uu1d_k$(seen0, url, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.url_1 = url;
        return $this;
      }
    }
    initMetadataForClass($, 'Embedded', VOID, VOID, [SigningRedirect()], VOID, VOID, {0: $serializer_getInstance_1});
    EmbeddedClass = $;
  }
  return EmbeddedClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        var tmp = getKClass(SigningRedirect());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_0 = [getKClass(EmailSent()), getKClass(Embedded())];
        var tmp_1 = EmailSent_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = [];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp_2 = [ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('EmailSent', tmp_1, tmp$ret$3), $serializer_getInstance_1()];
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$9 = [];
        return SealedClassSerializer().new_kotlinx_serialization_SealedClassSerializer_bm9rfz_k$('org.thecommunitygroupinc.cares.SigningRedirect', tmp, tmp_0, tmp_2, tmp$ret$9);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_2() {
  return Companion_instance_3;
}
var SigningRedirectClass;
function SigningRedirect() {
  if (SigningRedirectClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'SigningRedirect', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    SigningRedirectClass = $;
  }
  return SigningRedirectClass;
}
function SignerStatus$Companion$$childSerializers$_anonymous__9q9tgu() {
  return Companion_getInstance_4().serializer_9w0wvi_k$();
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_4 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, SignerStatus$Companion$$childSerializers$_anonymous__9q9tgu)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_3() {
  if (Companion_instance_4 === VOID)
    new (Companion_3())();
  return Companion_instance_4;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.SignerStatus', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('email', false);
        tmp0_serialDesc.addElement_5pzumi_k$('status', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_hepktt_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, EmailAddressSerializer_getInstance(), new (EmailAddress())(value.email_1));
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.status_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_hepktt_k$(encoder, value instanceof SignerStatus() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          var tmp = EmailAddressSerializer_getInstance();
          var tmp_0 = tmp4_local0;
          var tmp_1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp, tmp_0 == null ? null : new (EmailAddress())(tmp_0));
          tmp4_local0 = tmp_1 == null ? null : tmp_1.raw_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                var tmp_2 = EmailAddressSerializer_getInstance();
                var tmp_3 = tmp4_local0;
                var tmp_4 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp_2, tmp_3 == null ? null : new (EmailAddress())(tmp_3));
                tmp4_local0 = tmp_4 == null ? null : tmp_4.raw_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SignerStatus().new_org_thecommunitygroupinc_cares_SignerStatus_oulgmt_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_3().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [EmailAddressSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
var SignerStatusClass;
function SignerStatus() {
  if (SignerStatusClass === VOID) {
    class $ {
      constructor(email, status) {
        Companion_getInstance_3();
        this.email_1 = email;
        this.status_1 = status;
      }
      toString() {
        return 'SignerStatus(email=' + EmailAddress__toString_impl_artjh3(this.email_1) + ', status=' + this.status_1.toString() + ')';
      }
      hashCode() {
        var result = EmailAddress__hashCode_impl_wizg9y(this.email_1);
        result = imul(result, 31) + this.status_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SignerStatus()))
          return false;
        if (!(this.email_1 === other.email_1))
          return false;
        if (!this.status_1.equals(other.status_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_SignerStatus_oulgmt_k$(seen0, email, status, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.email_1 = email;
        $this.status_1 = status;
        return $this;
      }
    }
    initMetadataForClass($, 'SignerStatus', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    SignerStatusClass = $;
  }
  return SignerStatusClass;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function SignatureStatus$Companion$_anonymous__g63c6z() {
  return createSimpleEnumSerializer('org.thecommunitygroupinc.cares.SignatureStatus', values());
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  SignatureStatus_Created_instance = new (SignatureStatus())('Created', 0);
  SignatureStatus_Sent_instance = new (SignatureStatus())('Sent', 1);
  SignatureStatus_Delivered_instance = new (SignatureStatus())('Delivered', 2);
  SignatureStatus_Completed_instance = new (SignatureStatus())('Completed', 3);
  SignatureStatus_Declined_instance = new (SignatureStatus())('Declined', 4);
  SignatureStatus_Voided_instance = new (SignatureStatus())('Voided', 5);
  SignatureStatus_Expired_instance = new (SignatureStatus())('Expired', 6);
  SignatureStatus_Unknown_instance = new (SignatureStatus())('Unknown', 7);
  if (Companion_instance_5 === VOID) {
    Companion_instance;
    new (Companion_4())();
  }
}
var SignatureStatus_Created_instance;
var SignatureStatus_Sent_instance;
var SignatureStatus_Delivered_instance;
var SignatureStatus_Completed_instance;
var SignatureStatus_Declined_instance;
var SignatureStatus_Voided_instance;
var SignatureStatus_Expired_instance;
var SignatureStatus_Unknown_instance;
function values() {
  static_init();
  return [SignatureStatus_Created_getInstance(), SignatureStatus_Sent_getInstance(), SignatureStatus_Delivered_getInstance(), SignatureStatus_Completed_getInstance(), SignatureStatus_Declined_getInstance(), SignatureStatus_Voided_getInstance(), SignatureStatus_Expired_getInstance(), SignatureStatus_Unknown_getInstance()];
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, SignatureStatus$Companion$_anonymous__g63c6z);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_4() {
  static_init();
  return Companion_instance_5;
}
var SignatureStatusClass;
function SignatureStatus() {
  if (SignatureStatusClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'SignatureStatus', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    SignatureStatusClass = $;
  }
  return SignatureStatusClass;
}
function SignatureStatus_Created_getInstance() {
  static_init();
  return SignatureStatus_Created_instance;
}
function SignatureStatus_Sent_getInstance() {
  static_init();
  return SignatureStatus_Sent_instance;
}
function SignatureStatus_Delivered_getInstance() {
  static_init();
  return SignatureStatus_Delivered_instance;
}
function SignatureStatus_Completed_getInstance() {
  static_init();
  return SignatureStatus_Completed_instance;
}
function SignatureStatus_Declined_getInstance() {
  static_init();
  return SignatureStatus_Declined_instance;
}
function SignatureStatus_Voided_getInstance() {
  static_init();
  return SignatureStatus_Voided_instance;
}
function SignatureStatus_Expired_getInstance() {
  static_init();
  return SignatureStatus_Expired_instance;
}
function SignatureStatus_Unknown_getInstance() {
  static_init();
  return SignatureStatus_Unknown_instance;
}
//region block: init
Companion_instance_2 = new (Companion_1())();
Companion_instance_3 = new (Companion_2())();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance2chr590t9enwa,
  $serializer_getInstance as $serializer_getInstance1d82sdgf1kakj,
  Companion_getInstance as Companion_getInstance28su32ptmydjz,
  Companion_getInstance_3 as Companion_getInstancen8xc5ca99en9,
};
//endregion

//# sourceMappingURL=esignature.mjs.map
